import {noop} from 'vendor';
import {useField as useFormikField, useFormikContext} from 'formik';
import type {Control, Value} from 'types';
import type {FieldInputProps, FieldMetaProps, FieldHelperProps} from 'formik';

export function useField<V = any>(props: string | Control<V>): [FieldInputProps<Value<V>>, FieldMetaProps<V>, FieldHelperProps<Value<V>>, boolean] {
  if (typeof props !== 'string' && typeof props.setValue === 'function') {
    return [
      {
        name: props.name ?? 'unnamed',
        value: props.value,
        onChange: (event: React.ChangeEvent<HTMLInputElement>) => props.setValue?.(event.target.value, props.name),
        onBlur: noop
      },
      {
        value: props.value,
        touched: false,
        initialTouched: false
      },
      {
        setTouched: noop,
        setValue: props.setValue,
        setError: noop
      },
      false
    ];
  }
  return [
    ...useFormikField(props),
    useFormikContext()?.isSubmitting
  ];
}
